"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  gradient,
  ...props
}) => {
  const iconSharedUtils = require('./utils/icon-shared-utils');
  const hasGradient = iconSharedUtils.hasValidGradient(gradient);
  let fillValue = color;
  let gradientDefs;
  let gradientUtils;
  if (hasGradient) {
    gradientUtils = iconSharedUtils.getGradientUtils();
    const iconWebUtils = require('./utils/icon-web-utils');
    const gradientId = gradientUtils.generateGradientId(gradient);
    fillValue = `url(#${gradientId})`;
    gradientDefs = iconWebUtils.renderWebGradientDefs(gradient, gradientId);
  }
  const svgContent = (0, _jsxRuntime.jsxs)("svg", {
    ...props,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: size,
    width: size,
    fill: fillValue,
    role: title ? 'img' : undefined,
    "aria-hidden": !title,
    "aria-labelledby": titleId,
    children: [title ? (0, _jsxRuntime.jsx)("title", {
      id: titleId,
      children: title
    }) : null, (0, _jsxRuntime.jsx)("path", {
      d: "M15.5 1.012a2.194 2.194 0 0 1 1.969 2.182v4.28a1.097 1.097 0 0 1-2.194 0v-4.28h-9.53v17.612h9.53V16.58a1.097 1.097 0 1 1 2.194 0v4.226l-.01.223a2.196 2.196 0 0 1-1.959 1.96l-.225.011h-9.53l-.223-.012a2.195 2.195 0 0 1-1.96-1.959l-.011-.223V3.194c0-1.136.864-2.07 1.97-2.182L5.746 1h9.53l.225.012Z"
    }), (0, _jsxRuntime.jsx)("path", {
      d: "M18.84 7.83a.935.935 0 0 1 1.349 1.294l-4.898 5.283a.933.933 0 0 1-1.334.014l-2.076-2.076a.934.934 0 1 1 1.321-1.32l1.402 1.4L18.84 7.83Zm-7.492-3.559a.66.66 0 0 1 0 1.32H9.673a.66.66 0 0 1 0-1.32h1.675Z"
    })]
  });
  return hasGradient ? gradientUtils.addGradientToSvg(svgContent, gradientDefs) : svgContent;
};